import axios from '@/axios';
import { axiosTime } from '@/utils/moment';
import { removeEmpty } from '@/utils/helpers';
import settings from './settings';
import { AddMissionTransformer, AddVacationTransformer, getAttendanceTransformer } from './transformer';
import moment from 'moment'
export default {
	namespaced: true,

	modules: {
		settings,
	},

	actions: {
		// ---- attendance
		async fetchAttendance(
			_,
			{
				AttendType,
				DateFrom,
				DateTo,
				EmployeeIds,
				NameOrCode,
				IsNightShift,
				PermenantSystemId,
				SectionId,
				Valid,
				page,
				itemsPerPage,
				OrderByCode,
				OrderByLate,
				OrderByEarlyLeave,
				OrderByOverTime
			},
		) {
			return axios
				.get('/Attendances', {
					params: {
						AttendType,
						DateFrom: DateFrom,
						DateTo: DateTo,
						EmployeeIds,
						NameOrNum: NameOrCode,
						IsNightShift,
						PermenantSystemId,
						SectionId,
						Valid,
						page,
						perPage: itemsPerPage,
						OrderByCode,
						OrderByLate,
						OrderByEarlyLeave,
						OrderByOverTime
					},
				})
				.then((res) => {
					const count = res.headers['x-pagination-total-count'];
					const data = res.data;
					return { data: data.map((e) => getAttendanceTransformer(e)), count };
				});
		},
		async fetchAttendanceById(_, { id, DateFrom, DateTo }) {
			return axios
				.get(`/Attendances/Employee/${id}/BetweenDateToMonthOrDate`, {
					params: { dateTimeFrom: DateFrom, dateTimeTo: DateTo },
				})
				.then(({ data }) => {
					return data ? data.map((e) => getAttendanceTransformer(e)) : [];
				});
		},

		// ---- vacations
		async fetchVacations(
			_,
			{ DateFrom, DateTo, employeeIds, NameOrCode, SectionId, LeaveTypeId, page, itemsPerPage },
		) {
			return axios
				.get('/Leaves', {
					params: {
						DateFrom,
						DateTo,
						employeeIds,
						NameOrCode,
						SectionId,
						LeaveTypeId,
						page,
						perPage: itemsPerPage,
						Vacation: 0,
					},
				})

				.then((res) => {
					const count = res.headers['x-pagination-total-count'];
					const data = res.data;
					return { data: data, count };
				});
		},
		async fetchVacationsById(_, { DateFrom, DateTo, leaveTypeId, employeeId, id }) {
			return axios
				.get(`/Leaves/Employee/${id}/VacationType`, {
					params: { fromDate: DateFrom, toDate: DateTo, vacationType: 0, leaveTypeId, employeeId },
				})
				.then(({ data }) => data);
		},

		// ---- permissions
		async fetchPermissions(
			_,
			{ DateFrom, DateTo, employeeIds, NameOrCode, SectionId, page, itemsPerPage, LeaveTypeId },
		) {
			return axios
				.get('/Leaves', {
					params: {
						DateFrom,
						DateTo,
						employeeIds,
						NameOrCode,
						SectionId,
						page,
						perPage: itemsPerPage,
						Vacation: 1,
						LeaveTypeId
					},
				})
				.then((res) => {
					const count = res.headers['x-pagination-total-count'];
					const data = res.data;
					return { data: data, count };
				});
		},
		async fetchPermissionsById(_, { id, DateFrom, DateTo, leaveTypeId }) {
			return axios
				.get(`/Leaves/Employee/${id}/VacationType`, {
					params: { fromDate: DateFrom, toDate: DateTo, vacationType: 1, leaveTypeId },
				})
				.then(({ data }) => data);
		},

		// ---- missions
		async fetchMissions(_, { DateFrom, DateTo, employeeIds, NameOrCode, SectionId, page, itemsPerPage, TaskTypeId }) {
			return axios
				.get('/Tasks', {
					params: {
						DateFrom,
						DateTo,
						employeeIds,
						NameOrCode,
						SectionId,
						page,
						perPage: itemsPerPage,
						TaskTypeId
					},
				})
				.then((res) => {
					const count = res.headers['x-pagination-total-count'];
					const data = res.data;
					return { data: data, count };
				});
		},
		async fetchMissionsById(_, { id, DateFrom, DateTo, taskTypeId }) {
			return axios
				.get(`/Tasks/Employee/${id}`, { params: { fromDate: DateFrom, toDate: DateTo, taskTypeId } })
				.then(({ data }) => data);
		},

		// ---- add to employee
		async addAttendanceDay(_, { employeeIds, arrivalTime, departureTime, date }) {
			return axios.post('/Attendances/EmployeeWorkDay', {
				employeeIds,
				enterFrom: moment().format('YYYY-MM-DD') + 'T' + arrivalTime + ":00",
				enterTo: moment().format('YYYY-MM-DD') + 'T' + departureTime + ":00",
				date: date,
			});
		},
		deleteAttendances(_, { id }) {
			return axios.delete(`/Attendances/EmployeeWorkDay/${id}`)
		},
		async addVacation(_, prop) {
			return axios.postput('/Leaves', prop.id, removeEmpty(AddVacationTransformer(prop)));
		},
		async addMission(_, prop) {
			return axios.postput('/Tasks', prop.id, removeEmpty(AddMissionTransformer(prop)));
		},

		// ---- delete for employee
		async deleteVacation(_, id) {
			return axios.delete('Leaves/' + id);
		},
		async deleteMission(_, id) {
			return axios.delete('Tasks/' + id);
		},

		// ---- fingerprints
		async getFingerprint(_, { employeeCode, date }) {
			return axios
				.get('/Attendances/Fingerprint/Date', { params: { code: employeeCode, date } })
				.then(({ data }) => data);
		},
		async addFingerprint(_, { file }) {
			const formData = new FormData();
			formData.append('file', file);

			return axios.post('/Attendances/ImportFingerprint', formData).then(({ data }) => data);
		},
		async addOneFingerprint(_, { time, isArrival, employeeId, date, notes }) {
			return axios.post('/Attendances/FingerPrintFromUi', null, {
				params: {
					isArrival,
					employeeId,
					date,
					note: notes,
					time: axiosTime(time),
				}
			});
		},
		async editFingerprint({ commit }, {
			id,
			date,
			notes,
			time,
			isArrival,
			employeeId,
			fingerPrintStatus
		}) {
			return axios.put('/Attendances/EmployeeFingerPrint', 
				null,
				{
					headers: {
						'Content-Type': 'application/json'
					},
				
					params: {
						fingerPrintId: id,
						date: moment().format('YYYY-MM-DD') + 'T' + time + ":00",
						note: notes,
						time: moment().format('YYYY-MM-DD') + 'T' + time + ":00",
						isArrival,
						employeeId,
						fingerPrintStatus
					}
				});
			},
		},
};
